import CheckIcon from '@assets/icons/check-green.svg';
import CustomText from '@components/shared/CustomText';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { STEPS } from './constants';

import styles from './StepCounter.module.scss';

const StepCounter = ({ currentStep }) => {
  return (
    <div className={styles.container}>
      {STEPS.map(step => (
        <div
          key={step.id}
          className={clsx(styles.step, {
            [styles.activeStep]: currentStep.id === step.id,
          })}
        >
          <div
            className={clsx(styles.circle, {
              [styles.done]: step.id < currentStep.id,
              [styles.activeCircle]: currentStep.id === step.id,
            })}
          >
            {step.id < currentStep.id ? (
              <CheckIcon className={styles.icon} />
            ) : (
              <CustomText
                customStyle={styles.number}
              >{`${step.step}.`}</CustomText>
            )}
          </div>
          <CustomText
            bold
            customStyle={clsx(styles.title, {
              [styles.activeTitle]: currentStep.id === step.id,
            })}
          >
            {step.title}
          </CustomText>
        </div>
      ))}
    </div>
  );
};

StepCounter.propTypes = {
  currentStep: PropTypes.shape({
    id: PropTypes.number,
    step: PropTypes.number,
    title: PropTypes.string,
  }),
};

export default StepCounter;
